<template>
  <span
    v-show="showTooltip"
    v-transfer-dom
    :style="{ position: 'absolute', top: `${tooltipTop}px`, left: `${tooltipLeft}px` }"
    data-transfer="true"
  >
    <div class="custom-tooltip">
      <slot />
    </div>
  </span>
</template>

<script>
import TransferDom from '@/directives/transfer-dom'

export default {
  directives: {
    TransferDom
  },

  props: {
    showTooltip: {
      type: Boolean,
      default: false
    },

    tooltipTop: {
      type: Number,
      default: 0
    },

    tooltipLeft: {
      type: Number,
      default: 0
    }
  }
}
</script>
